// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.previewsourcegrid canvas-datagrid {
    font-size: 13px;
    font-family: "EYInterstate-light" !important;
  
    height: 500px !important;
    width: 100% !important;
  }

  .full.previewsourcegrid canvas {
    height: 500px !important;
    width: 100% !important;
  }`, "",{"version":3,"sources":["webpack://./src/app/features/inputcapture/inputcapture.component.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,4CAA4C;;IAE5C,wBAAwB;IACxB,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;IACxB,sBAAsB;EACxB","sourcesContent":[".previewsourcegrid canvas-datagrid {\r\n    font-size: 13px;\r\n    font-family: \"EYInterstate-light\" !important;\r\n  \r\n    height: 500px !important;\r\n    width: 100% !important;\r\n  }\r\n\r\n  .full.previewsourcegrid canvas {\r\n    height: 500px !important;\r\n    width: 100% !important;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
